import { useRoomStore } from '@features/room';
import { ParticipantTile } from './ParticipantTile';

/**
 * Renders all room participants in a responsive grid.
 * Layout adapts automatically:
 *   1 person   → full width (presenter mode)
 *   2 people   → side by side
 *   3-4        → 2×2
 *   5+         → 3-column wrapping grid
 */
export function ParticipantGrid() {
  const participants = useRoomStore((s) => s.participants);
  const connectionState = useRoomStore((s) => s.connectionState);

  if (connectionState === 'disconnected' || participants.length === 0) {
    return (
      <div className="flex h-full min-h-[320px] items-center justify-center rounded-lg border border-dashed border-surface-border bg-surface-2">
        <p className="text-sm text-text-muted">No participants yet</p>
      </div>
    );
  }

  const count = participants.length;
  const gridClass = getGridClass(count);

  return (
    <div className={`grid h-full min-h-[320px] auto-rows-fr gap-3 ${gridClass}`}>
      {participants.map((participant) => (
        <ParticipantTile
          key={participant.identity}
          participant={participant}
        />
      ))}
    </div>
  );
}

function getGridClass(count: number): string {
  if (count === 1) {
    return 'grid-cols-1';
  }

  if (count === 2) {
    return 'grid-cols-1 md:grid-cols-2';
  }

  if (count <= 4) {
    return 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4'; 
  }

  if (count <= 9) {
    return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
  }

  return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4';
}
